import React, { useContext, useEffect, useMemo } from "react";
import Select from "react-select";
import appContext from "../../../../context/app/appContext";
import { FaUserTie } from "react-icons/fa";

const EventOrganiserSelector = ({ data, onChange }) => {
  const { dbUser, allStaff } = useContext(appContext);

  const staffState = data.staff || { organiser: null, attending: [] };

  const staffOptions = useMemo(() => {
    return (allStaff || [])
      .filter((s) => s.staffEmpCode)
      .sort(
        (a, b) =>
          a.staffSurname.localeCompare(b.staffSurname) ||
          a.staffGvnName.localeCompare(b.staffGvnName)
      )
      .map((s) => ({
        value: s.staffEmpCode,
        label: `${s.staffGvnName} ${s.staffSurname}`,
        email: s.staffEmail,
        staffCode: s.staffCode,
        original: s,
      }));
  }, [allStaff]);

  useEffect(() => {
    if (dbUser?.staffEmpCode && allStaff?.length && !staffState.organiser) {
      const defaultOrganiser = {
        value: dbUser.staffEmpCode,
        label: `${dbUser.staffGvnName} ${dbUser.staffSurname}`,
        email: dbUser.staffEmail,
        staffCode: dbUser.staffCode,
        original: dbUser,
      };

      const isAlreadyIn = staffState.attending?.some(
        (s) => s.value === defaultOrganiser.value
      );

      onChange("staff", {
        organiser: defaultOrganiser,
        attending: isAlreadyIn
          ? staffState.attending
          : [...(staffState.attending || []), defaultOrganiser],
      });
    }
    // eslint-disable-next-line
  }, [dbUser, allStaff]); // Only run on mount or change

  const handleOrganiserChange = (selected) => {
    const attending = [...(staffState.attending || [])];
    const exists = attending.find((s) => s.value === selected?.value);

    const updatedAttending =
      selected && !exists ? [...attending, selected] : attending;

    onChange("staff", {
      organiser: selected,
      attending: updatedAttending,
    });
  };

  const formatOptionLabel = ({ label, email }) => (
    <div className="flex flex-col">
      <span className="flex items-center gap-2">
        <FaUserTie className="text-gray-500" />
        {label}
      </span>
      {email && <span className="text-xs text-gray-500 ml-6">{email}</span>}
    </div>
  );

  return (
    <div>
      <label className="block font-medium text-gray-700 mb-1">
        Event Organiser
      </label>
      <Select
        options={staffOptions}
        value={staffState.organiser}
        onChange={handleOrganiserChange}
        placeholder="Select organiser..."
        formatOptionLabel={formatOptionLabel}
        isClearable
      />
    </div>
  );
};

export default EventOrganiserSelector;
